import { Inject, Injectable } from "@angular/core";
import { IAddPaymentMethodModalService } from "./i-add-payment-method-modal.service";
import { AddPaymentMethodModalComponent } from "./add-payment-method-modal.component";
import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Injectable()
export class AddPaymentMethodModalService implements IAddPaymentMethodModalService {
	private _dialogRef: DynamicDialogRef | null = null;

	constructor(@Inject(modalServiceInjectionToken) private readonly _modalService: IModalService) {}

	public open(companyId: string): Promise<boolean> {
		return new Promise<boolean>((resolve) => {
			this._dialogRef = this._modalService.open(AddPaymentMethodModalComponent, {
				data: {
					companyId,
					onSaveCallback: () => {
						this._dialogRef?.close();
						this._dialogRef = null;
						resolve(true);
					},
					onCancelCallback: () => {
						resolve(false);
					}
				},
				header: "Zahlungsmethode hinzufügen",
				showHeader: true,
				closable: true,
				width: "550px",
				closeOnEscape: true,
				dismissableMask: true
			});

			this._dialogRef.onClose.subscribe(() => {
				this._dialogRef = null;
				resolve(false);
			});
		});
	}

	public close(): void {
		if (this._dialogRef) {
			this._dialogRef.close();
			this._dialogRef = null;
		}
	}
}
